import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={58}
    fill="none"
    {...props}
  >
    <g stroke="#DB4722" strokeLinecap="round" strokeLinejoin="round">
      <path strokeWidth={5} d="M16.916 28.167 29 40.25l12.083-12.083" />
      <path strokeWidth={4} d="m22.5 20 6.5 6 6.5-6" />
    </g>
  </svg>
)
export default SvgComponent
